import { Attr, BelongsTo, Model } from "spraypaint";

import type OrganisationSocialIntegration from "shared/resources/OrganisationSocialIntegration";
import { ApplicationRecord } from "shared/services/spraypaint";
import { type Nullable } from "shared/types";

@Model()
class InstagramHashtagsOrganisationSocialIntegration extends ApplicationRecord {
  static jsonapiType = "instagram_hashtags_organisation_social_integrations";

  @Attr({ persist: false }) archivedAt: Nullable<string>;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) hashtag: string;

  @Attr({ persist: false }) instagramHashtagId: string;

  @BelongsTo() organisationSocialIntegration: OrganisationSocialIntegration;

  @Attr({ persist: false }) updatedAt: string;
}

export default InstagramHashtagsOrganisationSocialIntegration;
